export type TutorialKey =
  | 'google_sheets'
  | 'google_calendar'
  | 'templates'
  | 'campaign_marketing'
  | 'campaign_renewal'
  | 'campaign_dynamic'
  | 'campaign_calendar'
  | 'whatsapp_meta_ai';

export type TutorialConfig = {
  youtubeId: string;
  title: string;
};

export const PAGE_TUTORIALS: Record<TutorialKey, TutorialConfig> = {
  google_sheets: { youtubeId: 'gcRd9L4nFfk', title: 'Tutorial Google Sheets' },
  google_calendar: { youtubeId: 'rMeBqN5J-B8', title: 'Tutorial Google Calendar' },
  templates: { youtubeId: 'yAhCQ2gbuS4', title: 'Tutorial Plantillas' },
  campaign_marketing: { youtubeId: 'aNYNc5y1-Uw', title: 'Tutorial Marketing' },
  campaign_renewal: { youtubeId: 't6EonfaoqSs', title: 'Tutorial Recordatorios Periódicos' },
  campaign_dynamic: { youtubeId: 'sW6AEWP0Kis', title: 'Tutorial Campañas Dinámicas' },
  campaign_calendar: { youtubeId: 'zcOPzsDGP3E', title: 'Tutorial Campaña Google Calendar' },
  whatsapp_meta_ai: { youtubeId: 'uERkG-a0BS4', title: 'Cómo desconectar Meta IA' },
};

export function getTutorial(key: TutorialKey): TutorialConfig | null {
  return PAGE_TUTORIALS[key] ?? null;
}

export function tutorialKeyForCampaignType(type: string): TutorialKey | null {
  if (type === 'Marketing') return 'campaign_marketing';
  if (type === 'Renovación de servicio') return 'campaign_renewal';
  if (type === 'Dynamic') return 'campaign_dynamic';
  if (type === 'Calendar') return 'campaign_calendar';
  return null;
}

/** Embed params: no playlist, limit related videos, hide annotations. */
export function youtubeEmbedUrl(youtubeId: string): string {
  const params = new URLSearchParams({
    autoplay: '1',
    rel: '0',
    modestbranding: '1',
    iv_load_policy: '3',
    playsinline: '1',
  });
  return `https://www.youtube-nocookie.com/embed/${youtubeId}?${params.toString()}`;
}
